module.exports = __webpack_public_path__ + "static/media/home-worker.1f381eda.svg";